import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import AccountLayoutHeader from 'components/layouts/AccountLayoutHeader/AccountLayoutHeader';
import ProductSnapshotCard from 'components/layouts/Snapshot/ProductSnapshotCard';
import AccountsDataProvider from 'components/shared/DataProviders/AccountsDataProvider';
import {
  activePlusMyAccountsUrl,
  planningDetailsUrl
} from 'services/Externals';
import { isActiveAdvisory, isActivePlus } from 'services/Products';
import { hasManagedAccounts } from 'state/view/ViewSelectors';
import { filterAccountsGridAccountType } from 'state/account/AccountsGridFilteringActions';
import {
  getCustomerWebView,
  getUberId
} from 'state/customer/CustomerSelectors';
import Store from 'state/Store';
import { getRasPerformanceData } from 'state/performance/ProductPerformanceSelectors';
import { getActivePlusAccountPerformanceData } from 'state/account/AccountPerformanceSelectors';
import { hasActiveAdvisoryPOA } from 'state/account/AccountSelectors';
import { rasPOAEnabled } from 'services/FeatureFlags';

const ProductSnapshotCardWithData = AccountsDataProvider(ProductSnapshotCard);

const AdvisorySnapshot = ({
  hasManagedAccounts,
  hasActiveAdvisoryPOA,
  rasPerformanceData,
  appPerformanceData,
  isCustomerWebView,
  uberId
}) => {
  const selectActiveAdvisoryAccounts = () => {
    Store.dispatch(filterAccountsGridAccountType('activeAdvisory'));
  };

  const activeAdvisoryFooter = (
    <Fragment>
      <Link
        to={{
          pathname: '/accounts',
          search: '?accountType=activeAdvisory'
        }}
        onClick={selectActiveAdvisoryAccounts}
        className="card-action-link">
        View Retirement Advisory Service Details
      </Link>
      <a
        rel="noreferrer noopener"
        className="card-action-link"
        href={planningDetailsUrl(isCustomerWebView)}>
        View Retirement Advisory Service Home
      </a>
    </Fragment>
  );

  const selectActivePlusAccounts = () => {
    Store.dispatch(filterAccountsGridAccountType('activePlus'));
  };
  const activePlusFooter = (
    <Fragment>
      <Link
        to={{
          pathname: '/accounts',
          search: '?accountType=activePlus'
        }}
        onClick={selectActivePlusAccounts}
        className="card-action-link">
        View ActivePlus Portfolio Details
      </Link>
      <a
        rel="noreferrer noopener"
        className="card-action-link"
        href={activePlusMyAccountsUrl(isCustomerWebView, uberId)}>
        View ActivePlus Portfolio Platform
      </a>
    </Fragment>
  );

  return (
    <Fragment>
      {hasManagedAccounts && (
        <div className="advisory-snapshot">
          <AccountLayoutHeader
            text="Advisory"
            link="/accounts"
            detailText="Advisory Details"
            hideDetailLink
            isSubheader
          />
          <ProductSnapshotCardWithData
            title="Retirement Advisory Service™"
            prrData={rasPerformanceData}
            footer={activeAdvisoryFooter}
            showCurrentPortfolio={rasPOAEnabled ? !hasActiveAdvisoryPOA : true}
            filter={(account) => isActiveAdvisory(account.productType)}
            hasIntradayRefresh={false}
          />
          <ProductSnapshotCardWithData
            title="ActivePlus Portfolios®"
            prrData={appPerformanceData}
            footer={activePlusFooter}
            filter={(account) => isActivePlus(account.productType)}
            hasIntradayRefresh={false}
          />
        </div>
      )}
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  hasManagedAccounts: hasManagedAccounts(state),
  hasActiveAdvisoryPOA: hasActiveAdvisoryPOA(state),
  rasPerformanceData: getRasPerformanceData(state),
  appPerformanceData: getActivePlusAccountPerformanceData(state),
  isCustomerWebView: getCustomerWebView(state),
  uberId: getUberId(state)
});

export default connect(mapStateToProps)(AdvisorySnapshot);
